import async from 'async';
import * as intl from 'wtg/intl';

var appModule = angular.module('SupportAgent',
 ['ngRoute', 'ngTable', 'ngMap', 'angularMoment', 'luegg.directives','ngSanitize',
  'nvd3', 'jkuri.gallery','gettext','ui.footable','chart.js','ngMaterial','ngMessages',
  'WTG.U','WTG.L','WTG.INTERACT','WTG.INTRACTABLE','WTG.IDA','WTG.PERSISTENCE',
  'speedTest','WTG.RESULTS','WTG.DIALOG','WTG.TRACEROUTE','WTG.SPECTRUM','WTG.C11N']);


appModule.config(['$locationProvider','$provide',
 function($locationProvider,$provide) {
  $locationProvider.hashPrefix('');
  $provide.decorator('$exceptionHandler', function() {
   return function(exception/*,cause*/) {
    WTG && WTG.REPORT && WTG.REPORT.exception(exception);
   };
  });
 }
]);

appModule
.component('wtgTicketRef',require('../components/wtg-ticket-ref').default)
.component('wtgTicketList',require('../components/wtg-ticket-list').default)
.component('wtgUserSearch',require('../components/wtg-user-search').default)
.component('wtgUserCreate',require('../components/wtg-user-create').default)
.component('wtgAccountInfo',require('../components/wtg-account-info').default)
.component('wtgIdaFrame',require('../components/wtg-ida-frame').default);

appModule.run(['$rootScope', '$location', '$route', '$q', 'EventHandler',
               'L','INTERACT','INTRACTABLE','PERSISTENCE',
 function ($rootScope, $location, $route, $q, EventHandler,
           L,INTERACT,INTRACTABLE,PERSISTENCE) {

  /* TODO: shouldn't be in the rootScope */
  /* TODO shouldn't have a copy all over the place */
  const wtgcp = (typeof WTGCONFIG !== 'undefined')?WTGCONFIG:{};
  $rootScope.strings = intl.set_language(PERSISTENCE.get('language',wtgcp.default_language||'en'));
  $rootScope.hidden_features = {};
  $rootScope.hidden_menu_items = (wtgcp.hidden_menu_items||[]).reduce(function(p,c) {
   p[c]=true;
   return p;
  },{});
  // TODO: ideally it should be a variable, not function
  $rootScope.isHidden = function(feature) {
   return $rootScope.hidden_features[feature] || $rootScope.hidden_menu_items[feature];
  };

  /* TODO: temporarily putting it in here */
  $rootScope.persist_login = function persist_login() {
   PERSISTENCE.put(['domain','acid','actype','acname','devid','token'].reduce(function(p,c) {
    p[c] = INTERACT.state.connection[c];
    return p;
   },{}));
  };
  $rootScope.unpersist_login = function unpersist_login() {
   // TODO: better delete than set to null…
   PERSISTENCE.put(['domain','acid','actype','acname','devid','token'].reduce(function(p,c) {
    p[c] = null;
    return p;
   },{}));
  };

  function persistent_login(cb) {
   var ld = PERSISTENCE.get({
    domain: undefined,
    actype: undefined,
    acname: undefined,
    devid: undefined,
    token: undefined,
    acid: undefined,
   });
   if(ld.domain!==undefined && ld.devid && ld.token) async.auto({
    connect: function connect(cb) {
     INTERACT.connect({domain:ld.domain},cb);
    },
    login: ['connect',function login(r,cb) {
     L.debug({ld},"perform token loginn");
     INTERACT.login(ld,cb);
    }]
   },cb);
   else cb(new Error('no auth info'));
  }

  $rootScope.$on('$routeChangeStart',
   function (event, next/*, current*/) {
    if (next && next.secure) {
     if (!INTERACT.is_logged_in()) {
      next.resolve = next.resolve||{};
      next.resolve.auth = function() {
       return $q(function(resolve,reject) {
        persistent_login(function(e) {
         if(e) return reject('auth');
         resolve();
        });
       });
      };
      return;
     }
     L.trace('Access allowed');
     //WTGL.log("route changed to - "+$route.current.scope.name);
     if ($route.current.scope && $route.current.scope.name === "support") {
      var acid = $rootScope.accountID;
      if(!acid) return;
      var account = INTERACT.get_account(acid);
      if(!account) return;
      var sd = account.sd;
      if((sd === undefined) ||
         (account.d[sd] &&
          (account.d[sd].id === undefined))) {
       /* TODO: this should not be, but I can't remove it right now, because I
        * have no idea what depends on it… */
       account.d = [{"name": "Loading..."}];
       account.sd = 0;
      }
     }
    }
   });
   $rootScope.$on('$routeChangeError',function(evt,to,from,reason) {
    if(reason=='auth') $location.path('/login');
   });

 }
]);
/* vim:set ts=8 sw=1 expandtab: */
